// Content wrapper component
import React from 'react';
import { Box } from '@mui/material';
import { useNotifications } from '../contexts/NotificationsContext';
import PageAlert from '../components/PageAlert';
import BreadCrumb from '../components/BreadCrumb';

interface ContentWrapperProps {
  children: React.ReactNode;
  breadcrumb?: boolean;
}

export const ContentWrapper: React.FC<ContentWrapperProps> = ({ children, breadcrumb }) => {
  const { latestNotification } = useNotifications();

  return (
    <Box component="main">
      {latestNotification && <PageAlert notification={latestNotification} />}
      {breadcrumb && <BreadCrumb />}
      {children}
    </Box>
  );
};

export default ContentWrapper;
